import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Tag, TYPOGRAPHY_VARIANTS, Typography } from '@didaskill/ui/design-system';

import messages from './QuestDialog.messages';
import * as styles from './QuestDialog.styles';

type AvailableFromProps = {
  availableAfterDays: number;
};

const AvailableFromBase = ({ availableAfterDays }: AvailableFromProps) => {
  return (
    <div css={styles.remainingTimeContainer}>
      <Typography variant={TYPOGRAPHY_VARIANTS.BODY_SMALL_BOLD} css={styles.remainingTime}>
        <FormattedMessage {...messages.AVAILABLE_FROM} />
      </Typography>
      <Tag
        label={
          <FormattedMessage
            {...messages.TIME}
            values={{
              count: availableAfterDays,
            }}
          />
        }
      />
    </div>
  );
};

AvailableFromBase.displayName = 'AvailableFrom';

export const AvailableFrom = memo(AvailableFromBase);
